import { render } from "./Hero.vue?vue&type=template&id=366577d2"
import script from "./Hero.vue?vue&type=script&lang=ts"
export * from "./Hero.vue?vue&type=script&lang=ts"

import "./Hero.vue?vue&type=style&index=0&id=366577d2&lang=scss"
script.render = render

export default script